module.exports = __webpack_public_path__ + "img/dataFailure.8d94039.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/preview/dataFailure.png
// module id = prBO
// module chunks = 6